import { Controller } from "@hotwired/stimulus";

// Pagina "Registra": propaga operatore e data predefiniti a tutte le righe,
// ricorda l'ultimo operatore usato e porta il focus alla riga successiva dopo una registrazione.
export default class extends Controller {
  static targets = ["defaultEmployee", "defaultData", "employee", "data"];

  connect() {
    try {
      const saved = localStorage.getItem("quickRecord.employee");
      if (saved && this.hasDefaultEmployeeTarget && !this.defaultEmployeeTarget.value) {
        this.setEmployee(this.defaultEmployeeTarget, saved);
      }
    } catch (e) { /* storage non disponibile */ }
    this.applyDefaults();
    this.boundAfterSubmit = this.afterSubmit.bind(this);
    this.element.addEventListener("turbo:submit-end", this.boundAfterSubmit);
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.boundAfterSubmit);
    clearTimeout(this.focusTimer);
  }

  applyDefaults() {
    const emp = this.hasDefaultEmployeeTarget ? this.defaultEmployeeTarget.value : "";
    const data = this.hasDefaultDataTarget ? this.defaultDataTarget.value : "";
    try { localStorage.setItem("quickRecord.employee", emp); } catch (e) { /* ignore */ }
    this.element.querySelectorAll("select.operatore-select, input.operatore-select").forEach((s) => { if (!s.dataset.touched) this.setEmployee(s, emp); });
    this.element.querySelectorAll("input[name='registrazione[data]']").forEach((i) => { if (data && !i.dataset.touched) i.value = data; });
  }

  setEmployee(select, value) {
    if (select.tomselect) select.tomselect.setValue(value, true);
    else select.value = value;
  }

  afterSubmit(event) {
    if (!event.detail.success) return;
    // dopo il replace Turbo la nuova riga arriva con i valori predefiniti: riapplica e sposta il focus
    this.focusTimer = setTimeout(() => {
      this.applyDefaults();
      const next = this.element.querySelector("tr:not(.table-success) input[name='registrazione[quantita]']");
      if (next) next.focus();
    }, 50);
  }
}
